import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import SectionContainer from "@/components/common/SectionContainer";
export default function GlampingHero() {
  return <section id="glamping-hero" className="bg-background w-full">
      {/* Hero Image */}
      <div className="w-full h-[40vh] md:h-[60vh] relative">
        <img alt="Luxurious yurt interior with made bed and rustic furniture" className="w-full h-full object-cover" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_interior_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_interior_hero.png-wvc-sizes" loading="lazy" src="https://paradisecovetx.com/wp-content/uploads/2026/09/glamping-at-the-cove-living-room.avif" />
      </div>

      {/* Content */}
      <SectionContainer className="py-12 md:py-16">
        <div className="max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-default font-light mb-8 uppercase tracking-wider text-foreground">
            Glamping
          </h1>

          <div className="space-y-6 text-muted-foreground font-sans text-lg leading-relaxed">
            <p>
              Have you been wanting to set out on a new adventure? Intrigued by the idea of camping, but without leaving behind the allure of luxury? Seeking that getaway to a remote lakefront private experience? This is the place!
            </p>
            <p>
              Glamping is all the rage these days, and Paradise Cove has brought it here for you! Tucked away on a private peninsula right on Lake Grapevine, you can experience the best of camping, with the glamour of a luxury hideaway.
            </p>
            <p>
              This luxurious Yurt (you're right, it is a funny name) is located on the border between Grapevine and Southlake, on the shores of Lake Grapevine. Spend your evening sitting by your own private fire pit - right by the lake! Roast marshmallows, make s'mores, or just watch the sparks flutter into the skies.
            </p>
          </div>

          <div className="mt-10 space-y-2 font-sans">
            <p className="text-foreground font-medium">
              Contact us for any questions or concerns.
            </p>
            <p>
              <Link href="tel:8173291668" className="text-primary hover:underline">
                CALL NOW: (817) 329-1668
              </Link>
            </p>
            <p>
              <Link to="mailto:info@paradisecovetx.com" className="text-primary hover:underline">
                info@paradisecovetx.com
              </Link>
            </p>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="https://www.vrbo.com/7454388ha?dateless=true" target="_blank" rel="noopener noreferrer" className="flex-1">
              <Button size="md" className="w-full py-6 text-lg uppercase tracking-wider">
                Book Now - VRBO
              </Button>
            </Link>
            <Link to="https://glampinghub.com/unitedstatesofamerica/south/texas/southlake/romantic-getaway-grapevine-texas/" target="_blank" rel="noopener noreferrer" className="flex-1">
              <Button size="md" className="w-full py-6 text-lg uppercase tracking-wider">
                Book Now - GlampingHub
              </Button>
            </Link>
          </div>
        </div>
      </SectionContainer>
    </section>;
}